<template>
  <focus-page :title="$t('resetPassword.title')" :message="message">
    <wo-alert v-if="error" mod-error > <span v-t="'resetPassword.error.invalid'" /></wo-alert>
    <form v-if="!requested">
      <wo-properties>
        <wo-properties-label>
          <wo-label for="email" v-t="'form.email.label'"></wo-label>
        </wo-properties-label>
        <wo-properties-value>
          <wo-input-field id="email" mod-block :placeholder="$t('form.email.placeholder')" v-model="email"
            autocomplete="email username" v-focus="true" />
        </wo-properties-value>
      </wo-properties>
      <wo-grid mod-stacked>
        <wo-column width="6" />
        <wo-column width="6" v-wo-v-align:center v-wo-align:right>
          <po-promise-button :disabled="!valid" label-key="resetPassword.action.request" @click="request" type="submit" />
        </wo-column>
      </wo-grid>
    </form>
    <account-focus-footer slot="footer" />
  </focus-page>
</template>

<script>

import FocusPage from '@/components/layout/FocusPage'
import AccountFocusFooter from '@/components/identity/AccountFocusFooter'

import { credentialsResetRepository } from '@/repository/identity'

export default {
  components: { FocusPage, AccountFocusFooter },
  data () {
    return {
      error: false,
      email: '',
      requested: false
    }
  },
  computed: {
    valid () {
      return this.email
    },
    message () {
      return this.requested ? this.$t('resetPassword.requested') : this.$t('resetPassword.message')
    }
  },
  methods: {
    request ({ detail }) {
      this.error = false
      this.$store.dispatch(credentialsResetRepository.create, { entity: { email: this.email } })
        .then(this.requestSuccess, this.requestFailure)
        .finally(detail.resolve)
    },
    requestSuccess () {
      this.requested = true
    },
    requestFailure () {
      this.error = true
    }
  }
}
</script>
